import { Tab, TabList, TabPanel, Tabs } from '@mui/joy';
import React from 'react';
import FragenViewer from './Tabs/FragenViewer';
import DateienViewer from './Tabs/DateienViewer';
import EmpfehlungEditor from '../components/EmpfehlungEditor';
import EmpfehlungsViewer from './Tabs/EmpfehlungsViewer';
import { useNavigate } from 'react-router-dom';

function TarifStandViewer({ data, fragen, bw, back,setback, perms, subkath }) {
    const [value, setValue] = React.useState(0);
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        if (newValue === 3){
            navigate("/page-history/tarif_stand" + data.id);
        }
        if (newValue === 4){
            setback(false);
        }
        setValue(newValue);
    };

    return (
        <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: 'divider' }}
        >
            <TabList>
                <Tab>Leistungsübersicht</Tab>
                <Tab>Dateien</Tab>
                <Tab>Empfehlung</Tab>
                <Tab>Historie</Tab>
                {back && (
                    <Tab>Zurück</Tab>
                )}
            </TabList>

            <TabPanel value={0}><FragenViewer data={data} fragen={fragen} bw={bw}/></TabPanel>
            <TabPanel value={1}><DateienViewer data={data} editperms={perms} subkath={subkath}/></TabPanel>
            <TabPanel value={2}><EmpfehlungsViewer data={data}/></TabPanel>
        </Tabs>
    );
}

export default TarifStandViewer;
